module.exports = __webpack_public_path__ + "static/media/video.31a3aca6.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/video.ogv
// module id = 202
// module chunks = 0